(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AElf", [], factory);
	else if(typeof exports === 'object')
		exports["AElf"] = factory();
	else
		root["AElf"] = factory();
})(globalThis, function() {
return 